export const categoryLandingContent = {
  'genre:lofi': {
    title: 'Free Lofi Music for Videos, Podcasts & Streams',
    body: [
      'Lofi music works well when your project needs a calm background that supports narration, study sessions, livestreams, vlogs, or social edits without stealing attention.',
      'Use these chill tracks for YouTube videos, podcast beds, stream intros, study playlists, and commercial creator projects under Viberary license terms.'
    ],
    links: [
      { label: 'Chillout music', to: '/mood/chillout' },
      { label: 'Podcast music guide', to: '/free-music-for-podcasts' },
      { label: 'Livestream music guide', to: '/free-music-for-livestreams' }
    ]
  },
  'genre:livestream': {
    title: 'Free Livestream Music for Creators',
    body: [
      'Livestream music should sit comfortably behind speaking, gameplay, chat, or live demonstrations. This collection focuses on background-friendly tracks for real-time content.',
      'Preview tracks before going live, keep the license page handy, and use music that fits the pace of your stream.'
    ],
    links: [
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'Livestream music guide', to: '/free-music-for-livestreams' }
    ]
  },
  'genre:cinematic-epic': {
    title: 'Free Cinematic Epic Music for Videos',
    body: [
      'Cinematic and epic tracks help trailers, sports edits, film scenes, game content, documentaries, and adventure videos feel larger and more dramatic.',
      'Choose a track that supports the emotional arc of your scene, then review the download page and license terms before publishing.'
    ],
    links: [
      { label: 'Adventure music', to: '/mood/adventure' },
      { label: 'Action / Sports music', to: '/mood/action-sports' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'genre:k-drama-ost': {
    title: 'Free K-Drama OST Music for Videos',
    body: [
      'K-Drama OST style music is useful for romantic edits, emotional storytelling, short films, drama recaps, character moments, and sentimental creator projects.',
      'Use these tracks when your video needs a softer story-driven mood, then follow the visible license terms on the download page.'
    ],
    links: [
      { label: 'Romantic music', to: '/mood/romantic' },
      { label: 'Sentimental music', to: '/mood/sentimental' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'genre:holiday-christmas': {
    title: 'Free Holiday Christmas Music for Videos',
    body: [
      'Holiday and Christmas music supports seasonal videos, festive ads, family vlogs, product promos, shorts, and social content during the busiest creator season.',
      'Preview cheerful, cozy, and magical tracks for seasonal creator projects.'
    ],
    links: [
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'Magical music', to: '/genre/magical' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'genre:ambient-atmospheric': {
    title: 'Free Ambient Atmospheric Music for Videos',
    body: [
      'Ambient atmospheric music is best when you need space, calm, and texture: meditation videos, sleep content, nature footage, documentaries, podcasts, and quiet scenes.',
      'Pick tracks that support the pace of your visuals or narration without crowding the message.'
    ],
    links: [
      { label: 'Chillout music', to: '/mood/chillout' },
      { label: 'Free background music', to: '/free-background-music-for-videos' },
      { label: 'Podcast music guide', to: '/free-music-for-podcasts' }
    ]
  },
  'genre:jazz-bossa': {
    title: 'Free Jazz and Bossa Nova Music for Videos',
    body: [
      'Jazz and bossa nova tracks add warmth, lounge energy, and stylish background texture to cafe videos, restaurant promos, travel vlogs, podcasts, and lifestyle content.',
      'Use this collection when your project needs a relaxed but polished sound.'
    ],
    links: [
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'Vlog / Travel music', to: '/mood/vlog-travel' },
      { label: 'Podcast music guide', to: '/free-music-for-podcasts' }
    ]
  },
  'mood:chillout': {
    title: 'Free Chillout Music for Background Videos',
    body: [
      'Chillout music is one of the safest starting points for background use because it can support videos, podcasts, streams, study sessions, and product content without feeling too intense.',
      'Preview relaxing tracks and choose one that leaves room for voice, dialogue, or visual pacing.'
    ],
    links: [
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'Ambient music', to: '/genre/ambient-atmospheric' },
      { label: 'Free background music guide', to: '/free-background-music-for-videos' }
    ]
  },
  'mood:happy': {
    title: 'Free Happy Music for YouTube & Social Videos',
    body: [
      'Happy music is a strong fit for positive YouTube videos, family-friendly edits, brand moments, product demos, social posts, and optimistic commercial projects.',
      'Use these upbeat tracks when your content needs energy, warmth, or a clear feel-good tone.'
    ],
    links: [
      { label: 'Pop music', to: '/genre/pop' },
      { label: 'Cute music', to: '/mood/cute' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'mood:corporate': {
    title: 'Free Corporate Music for Business Videos',
    body: [
      'Corporate music works best for business videos, product demos, explainer videos, pitch decks, training content, presentations, and brand campaigns.',
      'Choose a track that feels confident and clean, then review the license terms before adding it to your commercial project.'
    ],
    links: [
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' },
      { label: 'Optimistic music', to: '/mood/optimistic' },
      { label: 'Inspirational music', to: '/mood/inspirational' }
    ]
  },
  'mood:vlog-travel': {
    title: 'Free Vlog and Travel Music for Creators',
    body: [
      'Vlog and travel music helps creator content feel personal, moving, and easy to watch across YouTube, reels, lifestyle edits, podcasts, and commercial social posts.',
      'Preview tracks that match your pacing, destination, or story, then download from the track page.'
    ],
    links: [
      { label: 'Road Trip music', to: '/mood/road-trip' },
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  }
};

export const defaultLibraryIntro = {
  title: 'Free Music for Commercial Use',
  body: [
    'Browse royalty-free music for YouTube videos, podcasts, livestreams, ads, games, presentations, vlogs, and social content.',
    'Preview tracks, review the visible license terms, and download the version that fits your creator project.'
  ],
  links: [
    { label: 'YouTube music guide', to: '/free-music-for-youtube-creators' },
    { label: 'Commercial use guide', to: '/free-music-for-commercial-use' },
    { label: 'License Terms', to: '/license-terms' }
  ]
};

export const soundEffectsIntro = {
  title: 'Free Sound Effects for Videos and Games',
  body: [
    'Use Viberary sound effects to add notifications, transitions, reactions, and atmosphere to videos, games, podcasts, apps, and social content.',
    'Preview each sound, review the license terms, and download from the dedicated sound effect page.'
  ],
  links: [
    { label: 'Sound effects guide', to: '/sound-effects-for-videos' },
    { label: 'License Terms', to: '/license-terms' },
    { label: 'Contact', to: '/contact-us' }
  ]
};

export const creatorGuides = {
  '/free-music-for-youtube-creators': {
    title: 'Free Music for YouTube Creators',
    description: 'Find free royalty-free music for YouTube videos, Shorts, intros, vlogs, tutorials, and monetized creator projects.',
    sections: [
      {
        heading: 'Music for monetized YouTube videos',
        body: 'Viberary helps creators find music for YouTube videos, Shorts, vlogs, tutorials, explainers, product videos, and social edits. Choose a track, review the visible license terms, and keep the download page URL with your project notes.'
      },
      {
        heading: 'Best starting categories',
        body: 'Start with Lofi, Chillout, Happy, Corporate, Cinematic / Epic, Vlog / Travel, Jazz / Bossa Nova, and Ambient / Atmospheric depending on the tone of your video.'
      },
      {
        heading: 'Creator checklist',
        body: 'Preview the track, confirm it fits your narration or edit, read the license terms, copy any attribution text shown on the download page, and avoid claiming the music as your own original composition.'
      }
    ],
    links: [
      { label: 'Browse music', to: '/music' },
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'License Terms', to: '/license-terms' }
    ]
  },
  '/free-music-for-commercial-use': {
    title: 'Free Music for Commercial Use',
    description: 'Browse free music for ads, business videos, product demos, podcasts, livestreams, games, and other commercial creator projects.',
    sections: [
      {
        heading: 'Commercial project music',
        body: 'Viberary tracks can support commercial projects such as ads, product demos, presentations, training videos, livestreams, podcasts, games, client work, and social campaigns when the use follows the posted license terms.'
      },
      {
        heading: 'What to check before publishing',
        body: 'Review the download page and license terms, keep the track page URL, follow attribution instructions where required, and make sure the selected track fits the actual project usage.'
      }
    ],
    links: [
      { label: 'Corporate music', to: '/mood/corporate' },
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'Contact Viberary', to: '/contact-us' }
    ]
  },
  '/royalty-free-music-vs-copyright-free-music': {
    title: 'Royalty-Free Music vs Copyright-Free Music',
    description: 'Understand the difference between royalty-free, copyright-free, and copyright-safe music before choosing tracks for creator projects.',
    sections: [
      {
        heading: 'Royalty-free does not mean owner-free',
        body: 'Royalty-free usually means you can use a track under license without paying per-use royalties. It does not automatically mean the music has no copyright owner.'
      },
      {
        heading: 'Copyright-safe means follow the license',
        body: 'Viberary uses copyright-safe language to point creators toward tracks with visible usage terms. Always read the license terms and attribution instructions before using a track in a public project.'
      }
    ],
    links: [
      { label: 'License Terms', to: '/license-terms' },
      { label: 'FAQ', to: '/faq' },
      { label: 'Browse music', to: '/music' }
    ]
  },
  '/free-music-for-podcasts': {
    title: 'Free Music for Podcasts',
    description: 'Find free music for podcast intros, outros, transitions, narration beds, trailers, and commercial podcast projects.',
    sections: [
      {
        heading: 'Podcast-friendly music',
        body: 'Podcast music should support speech without competing with it. Lofi, Chillout, Jazz / Bossa Nova, Corporate, Ambient / Atmospheric, Spoken Word, and Cool tracks are good starting points.'
      },
      {
        heading: 'How to use it',
        body: 'Use Viberary tracks for intros, outros, short transitions, trailers, or soft background beds. Review the license terms and save the track page URL with your episode production notes.'
      }
    ],
    links: [
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'Jazz / Bossa Nova music', to: '/genre/jazz-bossa' },
      { label: 'Spoken Word music', to: '/genre/spoken-word' }
    ]
  },
  '/free-music-for-livestreams': {
    title: 'Free Music for Livestreams',
    description: 'Browse free background music for livestreams, stream intros, waiting screens, podcasts, and live creator content.',
    sections: [
      {
        heading: 'Background music for live content',
        body: 'Livestream music should sit behind speaking, chat, gameplay, demos, or waiting screens. Look for tracks that are steady, background-friendly, and not too distracting.'
      },
      {
        heading: 'Recommended categories',
        body: 'Start with Livestream, Lofi, Chillout, Cool, Corporate, Ambient / Atmospheric, and Happy depending on the energy of your stream.'
      }
    ],
    links: [
      { label: 'Livestream music', to: '/genre/livestream' },
      { label: 'Chillout music', to: '/mood/chillout' },
      { label: 'License Terms', to: '/license-terms' }
    ]
  },
  '/free-background-music-for-videos': {
    title: 'Free Background Music for Videos',
    description: 'Find free background music for videos, narration, tutorials, reels, ads, games, and social content.',
    sections: [
      {
        heading: 'Choose music that supports the story',
        body: 'Background music should match the pace and emotion of the video while leaving space for dialogue, voiceover, or on-screen action.'
      },
      {
        heading: 'Useful starting points',
        body: 'Try Chillout, Lofi, Ambient / Atmospheric, Corporate, Jazz / Bossa Nova, Happy, Sentimental, and Cinematic / Epic for different video styles.'
      }
    ],
    links: [
      { label: 'Browse music', to: '/music' },
      { label: 'Chillout music', to: '/mood/chillout' },
      { label: 'Corporate music', to: '/mood/corporate' }
    ]
  },
  '/sound-effects-for-videos': {
    title: 'Sound Effects for Videos',
    description: 'Download free sound effects for videos, games, apps, podcasts, notifications, transitions, and social content.',
    sections: [
      {
        heading: 'Sound effects for creator projects',
        body: 'Sound effects can make transitions, notifications, jokes, UI moments, reactions, and games feel more polished. Viberary gives each sound effect a dedicated download page with usage context.'
      },
      {
        heading: 'Before publishing',
        body: 'Preview the effect, confirm it is not confused with a download button or ad element, review the license terms, and keep the sound effect page URL for your project notes.'
      }
    ],
    links: [
      { label: 'Browse sound effects', to: '/soundeffects' },
      { label: 'License Terms', to: '/license-terms' },
      { label: 'Contact', to: '/contact-us' }
    ]
  }
};

export const faqRecommendations = [
  {
    question: 'Can I use Viberary music in monetized YouTube videos?',
    answer: 'Viberary tracks are provided for creator projects, including YouTube videos and monetized content, subject to the Viberary license terms shown on the site. Always review the license terms on the download page before publishing.'
  },
  {
    question: 'Is Viberary music free for commercial use?',
    answer: 'Viberary offers free music for personal and commercial projects under its posted license terms. Commercial uses can include videos, podcasts, ads, presentations, livestreams, and social content when they follow those terms.'
  },
  {
    question: 'Is Viberary music royalty-free?',
    answer: 'Viberary music is intended to be used without paying per-use royalties, subject to the license terms provided on Viberary. Review each download page and the license terms before using a track.'
  },
  {
    question: 'Is Viberary music copyright-free?',
    answer: 'No. Copyright-free and royalty-free are not the same thing. Viberary provides copyright-safe music for approved uses under its license terms, but the music may still be protected by copyright.'
  },
  {
    question: 'Can I use Viberary music in podcasts?',
    answer: 'Yes, Viberary music can be used in podcast projects when the use follows the posted license terms. Browse podcast-friendly categories such as Lofi, Chillout, Jazz / Bossa Nova, Spoken Word, and Corporate.'
  },
  {
    question: 'Can I use Viberary music in livestreams?',
    answer: 'Viberary includes livestream-friendly music for background use in live creator content. Review the license terms, then browse Livestream, Lofi, Chillout, Cool, and Corporate categories.'
  },
  {
    question: 'Do I need to give attribution?',
    answer: 'Follow the attribution instructions shown in Viberary license terms and on the download page for the track or sound effect you use.'
  },
  {
    question: 'Can I use Viberary sound effects in videos and games?',
    answer: 'Viberary sound effects can be used in creator projects according to the posted license terms. Check the sound effect download page for the correct attribution and usage details.'
  },
  {
    question: 'What kind of music is best for YouTube background music?',
    answer: 'For background music, start with Lofi, Chillout, Ambient / Atmospheric, Jazz / Bossa Nova, Corporate, Happy, and Vlog / Travel. Choose a track that supports the video without covering narration or dialogue.'
  },
  {
    question: 'How do I choose music that is safe for monetization?',
    answer: 'Use tracks from Viberary public library, keep a record of the download page and license terms, follow any attribution instructions, and avoid claiming the music as your own original composition.'
  }
];
